module.exports = "pegasus_template/assets/themecapture1/centered/200.png";